module.exports = __webpack_public_path__ + "static/media/download_icon.a4e2511e.svg";